import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FavoriteButtonWrapperContainer } from '@cian/favorites-assign-widget';
import { RoundButton, TooltipDesktop } from '@cian/ui-kit';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';

import { addToFavorite, deleteFromFavorite } from '../../actions/favorites';
import { selectIsAuthenticated } from '../../selectors/user';
import { TThunkDispatch } from '../../types/redux';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';

export function FavoritesButtonContainer() {
  const dispatch: TThunkDispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { offerId, isFavorite } = React.useContext(PromoOfferCardContext);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();

      if (isAuthenticated) {
        const action = isFavorite ? deleteFromFavorite : addToFavorite;
        dispatch(action(offerId));
      } else {
        if (window.waitForLoginPopup) {
          window.waitForLoginPopup('favorites');
        }
      }
    },
    [dispatch, isFavorite, offerId, isAuthenticated],
  );

  const handleLogin = React.useCallback(() => {
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup('favorites');
    }
  }, []);

  const button = (
    <TooltipDesktop theme="black" placement="left" title={isFavorite ? 'В избранном' : 'Добавить в избранное'}>
      <RoundButton
        theme="fill_dark"
        size="M"
        title="Добавить в избранное"
        onClick={handleClick}
        icon={isFavorite ? <IconToggleHeartOn16 color="icon-negative-default" /> : <IconToggleHeartOff16 />}
      />
    </TooltipDesktop>
  );

  return (
    <FavoriteButtonWrapperContainer
      offerId={offerId}
      placement="bottom-end"
      isAuthenticated={isAuthenticated}
      onWaitForLogin={handleLogin}
    >
      {button}
    </FavoriteButtonWrapperContainer>
  );
}
